"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var REGIONS = {
    ae: {
        seo: 'uae',
        api: 'ae',
        iso: 'AE',
        currencies: {
            en: 'AED',
            ar: 'د.إ.‏',
        },
    },
    sa: {
        seo: 'saudi',
        api: 'sa',
        iso: 'SA',
        currencies: {
            en: 'SAR',
            ar: 'ر.س.‏',
        },
    },
    eg: {
        seo: 'egypt',
        api: 'eg',
        iso: 'EG',
        currencies: {
            en: 'EGP',
            ar: 'جنيه',
        },
    },
};
var Locale = /** @class */ (function () {
    function Locale() {
    }
    Locale.isInitialized = function (reqLocale) {
        return !!this.locales[reqLocale];
    };
    Locale.initialize = function (reqLocale) {
        // Initialize
        var _a = reqLocale.split('-'), lang = _a[0], isoRegion = _a[1];
        // Convert SEO regions to API
        var seoRegion;
        switch (isoRegion) {
            case 'EG':
                seoRegion = 'egypt';
                break;
            case 'SA':
                seoRegion = 'saudi';
                break;
            case 'AE':
                seoRegion = 'uae';
                break;
            default:
                throw new Error('Could not determine region');
        }
        var apiRegion = isoRegion.toLowerCase();
        if (this.locales[reqLocale]) {
            return;
        }
        // Finally, set the locale object to use everywhere
        this.locales[reqLocale] = {
            lang: lang,
            seoRegion: seoRegion,
            apiRegion: apiRegion,
            seoLocale: seoRegion + "-" + lang,
            apiLocale: lang + "-" + apiRegion,
            isoLocale: lang + "-" + isoRegion,
            isEnglish: lang === 'en',
            isArabic: lang === 'ar',
            isUAE: isoRegion === 'AE',
            isSaudi: isoRegion === 'SA',
            isEgypt: isoRegion === 'EG',
            currencyCode: REGIONS[apiRegion].currencies[lang],
            currencyCodeEN: REGIONS[apiRegion].currencies.en,
        };
    };
    Locale.getLocaleObject = function (reqLocale) {
        if (reqLocale === void 0) { reqLocale = 'en-AE'; }
        if (this.locales[reqLocale]) {
            return this.locales[reqLocale];
        }
        this.initialize(reqLocale);
        return this.locales[reqLocale];
    };
    Locale.getAPIRegion = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].apiRegion;
    };
    Locale.getSEORegion = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].seoRegion;
    };
    Locale.getAPILocale = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].apiLocale;
    };
    Locale.getSEOLocale = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].seoLocale;
    };
    Locale.getCurrencyCode = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].currencyCode;
    };
    Locale.getCurrencyCodeEN = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].currencyCodeEN;
    };
    Locale.getISOLocale = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].isoLocale;
    };
    Locale.isArabic = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].isArabic;
    };
    Locale.isEgypt = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].isEgypt;
    };
    Locale.getLang = function (reqLocale) {
        this.getLocaleObject(reqLocale);
        return this.locales[reqLocale].lang;
    };
    Locale.locales = {};
    return Locale;
}());
exports.default = Locale;
//# sourceMappingURL=locale.js.map